import { HelpCircle } from 'lucide-react';
import * as React from 'react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { helpContentMap } from '@/data/help-content';
import { cn } from '@/lib/utils';
import type { ScreenId } from '@/types/help-support';
import { HelpSupportDrawer } from './help-support-drawer';

interface HelpSupportButtonProps {
  screenId: ScreenId;
  className?: string;
  variant?: 'default' | 'outline' | 'ghost' | 'secondary';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

export function HelpSupportButton({
  screenId,
  className,
  variant = 'outline',
  size = 'default',
}: HelpSupportButtonProps) {
  const [open, setOpen] = React.useState(false);
  const content = helpContentMap[screenId];

  if (!content) {
    console.warn(`No help content found for screen: ${screenId}`);
    return null;
  }

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant={variant}
              size={size}
              onClick={() => setOpen(true)}
              className={cn('gap-2', className)}
              aria-label="Get help with this page"
            >
              <HelpCircle className="h-4 w-4" />
              <span>Help</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Get help with this page</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <HelpSupportDrawer open={open} onOpenChange={setOpen} content={content} />
    </>
  );
}
